<div class="container">
  <form (ngSubmit)="loginCredentialsForm(credSetForm)" #credSetForm="ngForm">
    <div class="form-row">
      <h6 *ngIf = "!editmode"><strong>Enter the login credentials</strong></h6>
      <h6 *ngIf = "editmode"><strong>Login credentials</strong></h6>
    </div>

    <div class="form-row">
      <div class="form-group col-md-4">
        <label><span class="required"></span>Email address</label>
        <input
          class="form-control"
          #username="ngModel"
          [disabled]= "editmode"
          required
          name="userName"
          [(ngModel)]="employee.username"
          type="email"
          email
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"
          placeholder="Enter"
        />
      </div>
    </div>

    <div class="row">
      <!---error validation results --->
      <div class="form-group">
        <div
          class="mb-minus-2-5 error pl-0"
          *ngIf="credSetForm.submitted && username.errors?.required"
        >
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
        <div
          class="mb-minus-2-5 error pl-1"
          *ngIf="credSetForm.submitted && username.errors?.pattern"
        >
          {{ getGlobalErrorMessages("INVALID_EMAIL") }}
        </div>
      </div>
    </div>

    <div [ngClass]="{'hide':editmode}" class="form-row">
      <div class="form-group col-md-4 pl-0">
        <label><span class="required"></span>Password</label>
        <div class="inpt-outline pltu pr-1">
          <input
            class="w-100 unset-inpt-fld"
            #password="ngModel"
            name="password"
            required
            [(ngModel)]="employee.password"
            [type]="pwd_hide ? 'text':'password'"
            placeholder="Enter"
          />
          <mat-icon matTooltip="Show/Hide" class="mt-1" matSuffix (click)="pwd_hide  = !pwd_hide ">
            {{pwd_hide ?'visibility':'visibility_off'}}
           </mat-icon>
        </div>
      </div>
      <div class="form-group col-md-4 pl-2">
        <label><span class="required"></span>Confirm Password</label>
        <div class="inpt-outline pltu pr-1">
          <input
            class="w-100 unset-inpt-fld"
            required
            #confirmpassword="ngModel"
            name="confirmPassword"
            [(ngModel)]="employee.confirmPassword"
            [type]="pwd_confirm_hide ? 'text':'password'"
            placeholder="Enter"
          />
          <mat-icon matTooltip="Show/Hide" class="mt-1" matSuffix (click)="pwd_confirm_hide  = !pwd_confirm_hide ">
            {{pwd_confirm_hide ?'visibility':'visibility_off'}}
           </mat-icon>
        </div>
      </div>
    </div>

    <div [ngClass]="{'hide':editmode}" class="row">
      <!---error validation results --->
      <div class="form-group col-md-4">
        <div
          class="mb-minus-2-5 error pl-1"
          *ngIf="credSetForm.submitted && password.errors?.required"
        >
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="form-group col-md-4">
        <div
          class="mb-minus-2-5 error"
          *ngIf="credSetForm.submitted && confirmpassword.errors?.required"
        >
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
    </div>

    <div class="row error" [ngClass]="{'hide':editmode}"  *ngIf="credSetForm.submitted && !confirmpassword.errors?.required &&
      this.employee.password !== this.employee.confirmPassword">
      <!---error validation results --->
      <span class="form-group col-md-12">
        {{ getGlobalErrorMessages("CONFIRM_PASSWORD") }}
      </span>
    </div>

    <div  [ngClass]="{'hide':editmode}"  class="form-row float-right">
      <button type="submit" class="ml-2 im-btn btn-primary im-btn-md" mat-button>
        Send Invite
      </button>
     <!---
        <button  *ngIf="editmode" (click) = "changePassword()" type="button" class="ml-2 im-btn btn-primary im-btn-md" mat-button>
        Save
      </button>
      --->
    </div>
  </form>
</div>
